import { gql } from "@apollo/client";

export const GET_ALL_TIPO_PRESUPUESTO = gql`
query GetAllTipoPresupuesto {
    allTipoPresupuesto {
        idTipoPresupuesto
        descripcion
    }
}
`;

export const adaptTipo = (tipo) => {
  return {
    id: tipo?.idTipoPresupuesto,
    displayName: tipo?.descripcion
  };
};

export const adaptTipoPresupuestoArray = (
allTipoPresupuesto) =>
{
  return structuredClone(allTipoPresupuesto)?.
  map((tipo) => adaptTipo(tipo));
};